import Vue from "vue";
import Router from "vue-router";
import i18n from "@/i18n";

const NewsList = () => import("@/pages/NewsList.vue");
const EditNews = () => import("@/pages/EditNews.vue");
const NewsDetail = () => import("@/pages/NewsDetail.vue");
const Login = () => import("@/pages/Login.vue");

const Home = () => import("@/views/home/Home.vue");
const Products = () => import("@/views/products/Products.vue");
const News = () => import("@/views/news/News.vue");
const About = () => import("@/views/about/About.vue");
const Contact = () => import("@/views/contact/ContactHome.vue");
const Join = () => import("@/views/join/Join.vue");
const ContactDetail = () => import("@/views/contact/Contact.vue");

// const N20240408 = () => import("@/views/news/newspage/N20240408.vue");
// const N20231214 = () => import("@/views/news/newspage/N20231214.vue");
// const N20231108 = () => import("@/views/news/newspage/N20231108.vue");
// const N20240715 = () => import("@/views/news/newspage/N20240715.vue");
// const N20241012 = () => import("@/views/news/newspage/N20241012.vue");
// const N20240906 = () => import("@/views/news/newspage/N20240906.vue");
// const N20241016 = () => import("@/views/news/newspage/N20241016.vue");
// const N20241108 = () => import("@/views/news/newspage/N20241108.vue");
// const N20241119 = () => import("@/views/news/newspage/N20241119.vue");
// const N20241216 = () => import("@/views/news/newspage/N20241216.vue");

const AccessDeclaration = () =>
  import("@/components/laws/AccessDeclaration.vue");
const TermsOfUse = () => import("@/components/laws/TermsOfUse.vue");

//footer详情页路由
const pd2 = () => import("@/components/footDetail/pd2");
const pd3 = () => import("@/components/footDetail/pd3");
const pd4 = () => import("@/components/footDetail/pd4");
const pd5 = () => import("@/components/footDetail/pd5");
const pd6 = () => import("@/components/footDetail/pd6");
const pd7 = () => import("@/components/footDetail/pd7");
const pd8 = () => import("@/components/footDetail/pd8");

const ProductsHome = () =>
  import("@/views/products/productsslot/productshome/ProductsHome.vue");
const AEItem = () => import("@/views/products/productsslot/sort/AEItem.vue");
const CeloscopeItem = () =>
  import("@/views/products/productsslot/sort/CeloscopeItem.vue");
const UreterItem = () =>
  import("@/views/products/productsslot/sort/UreterItem.vue");
const ENTItem = () => import("@/views/products/productsslot/sort/ENTItem.vue");
const HysteroscopeItem = () =>
  import("@/views/products/productsslot/sort/HysteroscopeItem.vue");
const ArthroscopyItem = () =>
  import("@/views/products/productsslot/sort/ArthroscopyItem.vue");
const UreterItemDetail = () =>
  import("@/views/products/productsslot/sort/detail/UreterItemDetail.vue");
const CeloscopeItemDetail = () =>
  import("@/views/products/productsslot/sort/detail/CeloscopeItemDetail.vue");
const ProductDetail = () =>
  import("@/views/products/productsslot/sort/detail/ProductDetail.vue");
const ENTItemDetail = () =>
  import("@/views/products/productsslot/sort/detail/ENTItemDetail.vue");
const ArthroscopyItemDetail = () =>
  import("@/views/products/productsslot/sort/detail/ArthroscopyItemDetail.vue");
const HysteroscopeItemDetail = () =>
  import(
    "@/views/products/productsslot/sort/detail/HysteroscopeItemDetail.vue"
  );

const HotMidDetail = () =>
  import("@/views/products/productsslot/sort/detail/HotMidDetail.vue");
const HotLDetail = () =>
  import("@/views/products/productsslot/sort/detail/HotLDetail.vue");
const HotRDetail = () =>
  import("@/views/products/productsslot/sort/detail/HotRDetail.vue");

const MedicalEndscopicCameraSystem = () =>
  import(
    "@/views/products/productsslot/Secondary_menu/MedicalEndscopicCameraSystem"
  );
const MedicalTrolley = () =>
  import("@/views/products/productsslot/Secondary_menu/MedicalTrolley");
const Medicalmonitor = () =>
  import("@/views/products/productsslot/Secondary_menu/Medicalmonitor");
const Laparoscopy = () =>
  import("@/views/products/productsslot/Secondary_menu/Laparoscopy");
const AbdominalsurgicalInstruments = () =>
  import(
    "@/views/products/productsslot/Secondary_menu/AbdominalsurgicalInstruments"
  );
const ThoracicSurgeryInstruments = () =>
  import(
    "@/views/products/productsslot/Secondary_menu/ThoracicSurgeryInstruments"
  );
const otoscope = () =>
  import("@/views/products/productsslot/Secondary_menu/otoscope");
const OtologySI = () =>
  import("@/views/products/productsslot/Secondary_menu/OtologySI");
const Sinusscope = () =>
  import("@/views/products/productsslot/Secondary_menu/Sinusscope");
const RhinologySI = () =>
  import("@/views/products/productsslot/Secondary_menu/RhinologySI");
const laryngoscope = () =>
  import("@/views/products/productsslot/Secondary_menu/laryngoscope");
const LaryngealSI = () =>
  import("@/views/products/productsslot/Secondary_menu/LaryngealSI");
const arthroscope = () =>
  import("@/views/products/productsslot/Secondary_menu/arthroscope");
const Obturator = () =>
  import("@/views/products/productsslot/Secondary_menu/Obturator");
const ArthroscopicSI = () =>
  import("@/views/products/productsslot/Secondary_menu/ArthroscopicSI");

Vue.use(Router);

const routes = [
  {
    path: "/:lang(en)?",
    component: Home,
  },
  {
    path: "/:lang(en)?/home",
    component: Home,
  },

  {
    path: "/:lang(en)?/login",
    component: Login,
  },
  {
    path: "/:lang(en)?/list",
    component: NewsList,
    meta: { requiresAuth: true },
  },
  {
    path: "/:lang(en)?/editnews",
    component: EditNews,
    name: "editnews",
    meta: { requiresAuth: true }, // 需要登录访问
  },
  {
    path: "/:lang(en)?/detail/:id", // 显示新闻详情页面
    component: NewsDetail,
    props: true,
  },

  {
    path: "/:lang(en)?/products",
    component: Products,
    children: [
      {
        path: "",
        redirect: "productshome",
      },
      {
        path: "productshome",
        component: ProductsHome,
      },
      {
        path: "accessory",
        component: AEItem,
      },
      {
        path: "celoscope",
        component: CeloscopeItem,
      },
      {
        path: "ureter",
        component: UreterItem,
      },
      {
        path: "ent",
        component: ENTItem,
      },
      {
        path: "hysteroscope",
        component: HysteroscopeItem,
      },
      {
        path: "arthroscopy",
        component: ArthroscopyItem,
      },

      {
        path: "MedicalEndscopicCameraSystem",
        component: MedicalEndscopicCameraSystem,
      },
      {
        path: "MedicalTrolley",
        component: MedicalTrolley,
      },
      {
        path: "Medicalmonitor",
        component: Medicalmonitor,
      },
      {
        path: "Laparoscopy",
        component: Laparoscopy,
      },
      {
        path: "AbdominalsurgicalInstruments",
        component: AbdominalsurgicalInstruments,
      },
      {
        path: "ThoracicSurgeryInstruments",
        component: ThoracicSurgeryInstruments,
      },
      {
        path: "otoscope",
        component: otoscope,
      },
      {
        path: "OtologySI",
        component: OtologySI,
      },
      {
        path: "Sinusscope",
        component: Sinusscope,
      },
      {
        path: "RhinologySI",
        component: RhinologySI,
      },
      {
        path: "laryngoscope",
        component: laryngoscope,
      },
      {
        path: "LaryngealSI",
        component: LaryngealSI,
      },
      {
        path: "arthroscope",
        component: arthroscope,
      },
      {
        path: "Obturator",
        component: Obturator,
      },
      {
        path: "ArthroscopicSI",
        component: ArthroscopicSI,
      },
    ],
  },
  {
    path: "/:lang(en)?/news",
    component: News,
  },
  {
    path: "/:lang(en)?/about",
    component: About,
  },
  {
    path: "/:lang(en)?/contact",
    component: Contact,
  },
  {
    path: "/:lang(en)?/contactdetail",
    component: ContactDetail,
  },
  {
    path: "/:lang(en)?/join",
    component: Join,
  },

  // news 子页面路由
  // {
  //   path: "/:lang(en)?/news/n20240408",
  //   component: N20240408,
  // },
  // {
  //   path: "/:lang(en)?/news/n20231214",
  //   component: N20231214,
  // },
  // {
  //   path: "/:lang(en)?/news/n20231108",
  //   component: N20231108,
  // },
  // {
  //   path: "/:lang(en)?/news/n20240715",
  //   component: N20240715,
  // },
  // {
  //   path: "/:lang(en)?/news/n20241012",
  //   component: N20241012,
  // },
  // {
  //   path: "/:lang(en)?/news/n20240906",
  //   component: N20240906,
  // },
  // {
  //   path: "/:lang(en)?/news/n20241016",
  //   component: N20241016,
  // },
  // {
  //   path: "/:lang(en)?/news/n20241108",
  //   component: N20241108,
  // },
  // {
  //   path: "/:lang(en)?/news/n20241119",
  //   component: N20241119,
  // },
  // {
  //   path: "/:lang(en)?/news/n20241216",
  //   component: N20241216,
  // },

  // laws 子页面路由
  {
    path: "/:lang(en)?/laws/access-declaration",
    component: AccessDeclaration,
  },
  {
    path: "/:lang(en)?/laws/terms-of-use",
    component: TermsOfUse,
  },

  //footer详情页路由
  {
    path: "/:lang(en)?/footDetail/pd2",
    component: pd2,
  },
  {
    path: "/:lang(en)?/footDetail/pd3",
    component: pd3,
  },
  {
    path: "/:lang(en)?/footDetail/pd4",
    component: pd4,
  },
  {
    path: "/:lang(en)?/footDetail/pd5",
    component: pd5,
  },
  {
    path: "/:lang(en)?/footDetail/pd6",
    component: pd6,
  },
  {
    path: "/:lang(en)?/footDetail/pd7",
    component: pd7,
  },
  {
    path: "/:lang(en)?/footDetail/pd8",
    component: pd8,
  },

  {
    path: "/:lang(en)?/accessory/:type/:productId",
    name: "ProductDetail",
    component: ProductDetail,
  },
  {
    path: "/:lang(en)?/ureter/:type/:productId",
    name: "UreterItemDetail",
    component: UreterItemDetail,
  },
  {
    path: "/:lang(en)?/celoscope/:type/:productId",
    name: "CeloscopeItemDetail",
    component: CeloscopeItemDetail,
  },
  {
    path: "/:lang(en)?/tne/:type/:productId",
    name: "ENTItemDetail",
    component: ENTItemDetail,
  },
  {
    path: "/:lang(en)?/arthroscopy/:type/:productId",
    name: "ArthroscopyItemDetail",
    component: ArthroscopyItemDetail,
  },
  {
    path: "/:lang(en)?/hysteroscope/:type/:productId",
    name: "HysteroscopeItemDetail",
    component: HysteroscopeItemDetail,
  },

  {
    path: "/:lang(en)?/hot/hotmiddetail",
    component: HotMidDetail,
  },
  {
    path: "/:lang(en)?/hot/hotldetail",
    component: HotLDetail,
  },
  {
    path: "/:lang(en)?/hot/hotrdetail",
    component: HotRDetail,
  },

  {
    path: "*",
    redirect: "/:lang(en)?/", // 未知页面重定向至主页
  },
];

const router = new Router({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

// 路由守卫用于设置语言
router.beforeEach((to, from, next) => {
  const lang = i18n.locale;
  const token = localStorage.getItem("user-token");
  const loginTime = localStorage.getItem("login-time");

  // 判断登录是否超时  1 小时
  const isLoginExpired =
    token && loginTime && Date.now() - parseInt(loginTime, 10) > 3600000;

  if (isLoginExpired) {
    // 清除登录信息
    localStorage.removeItem("user-token");
    localStorage.removeItem("login-time");

    // 提示用户并重定向到登录页面
    alert("登录已超时，请重新登录。");
    next({ path: "/login" });
    return;
  }

  // 语言切换逻辑
  if (to.path.startsWith("/en") && lang === "zh") {
    const newPath = to.path.replace("/en", "");
    next(newPath || "/");
  } else if (!to.path.startsWith("/en") && lang === "en") {
    const newPath = `/en${to.path}`;
    next(newPath);
  } else {
    next();
  }

  // 验证路由访问权限
  if (to.matched.some((record) => record.meta.requiresAuth) && !token) {
    alert("请先登录后访问。");
    next({ path: "/" });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js